import { ACTION_TYPES } from "../../actions/collateral/CollateralActions"

const initialState = {
    list: [],
    listOrders: [],
    evidence: [],
    workOrderDetail: {},
    subStage: [],
    subStagePerOrder: [],
    rigths: [],
    rigthsPerOrder: [],
    comments: [],
    invoiceErrors: [],
    invoiceList: [],
    resultInvoice: {},
    resultComplement: {},
    listInvoicesComplement: {},
    listRejectedInvoices: [],
    statePlate: [],
    typePlate: [],
    woprocedurePlate: 0
}
export const CollateralReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.CLEAN_USER_PROFILE:
            return {
                ...state,
                list: [],
                listOrders: [],
                evidence: [],
                orderDetail: {},
                workOrderDetail: {},
                subStage: [],
                subStagePerOrder: [],
                rigths: [],
                rigthsPerOrder: [],
                comments: [],
                invoiceErrors: [],
                invoiceList: [],
            }
        case ACTION_TYPES.FETCH_DASHBOARD:
            return {
                ...state,
                list: [...action.payload]
            }
        case ACTION_TYPES.FETCH_OC_BY_STATUS:
            return {
                ...state,
                listOrders: [...action.payload]
            }
        case ACTION_TYPES.FETCH_FILTER_BY_DATE:
            return {
                ...state,
                listOrders: [...action.payload]
            }
        case ACTION_TYPES.FETCH_FILTER_BY_TEXT:
            return {
                ...state,
                listOrders: [...action.payload]
            }
        case ACTION_TYPES.FETCH_ORDER_DETAIL:
            return {
                ...state,
                orderDetail: action.payload
            }
        case ACTION_TYPES.FETCH_EVIDENCE:
            return {
                ...state,
                evidence: [...action.payload]
            }
        case ACTION_TYPES.FETCH_INVOICE_HISTORY:
            return {
                ...state,
                invoiceList: [...action.payload]
            }
        case ACTION_TYPES.RESULT_UPLOAD_INVOICE:
            return {
                ...state,
                resultInvoice: action.payload
            }
        case ACTION_TYPES.RESULT_UPLOAD_COMPLEMENT:
            return {
                ...state,
                resultComplement: action.payload
            }
        case ACTION_TYPES.FETCH_INVOICE_COMPLEMENT:
            return {
                ...state,
                listInvoicesComplement: action.payload
            }
        case ACTION_TYPES.FETCH_REJECTED_INVOICE:
            return {
                ...state,
                listRejectedInvoices: [...action.payload]
            }
        case ACTION_TYPES.FETCH_WORK_ORDER_DETAIL:
            return {
                ...state,
                workOrderDetail: action.payload
            }
        case ACTION_TYPES.FETCH_SUBSTAGE_PER_ORDER:
            return {
                ...state,
                subStagePerOrder: action.payload
            }
        case ACTION_TYPES.FETCH_SUBSTAGE:
            return {
                ...state,
                subStage: action.payload
            }
        case ACTION_TYPES.FETCH_RIGTHS_PER_ORDER:
            return {
                ...state,
                rigthsPerOrder: action.payload
            }
        case ACTION_TYPES.FETCH_RIGTHS:
            return {
                ...state,
                rigths: action.payload
            }
        case ACTION_TYPES.FETCH_COMMENTS:
            return {
                ...state,
                comments: [...action.payload]
            }
        case ACTION_TYPES.FETCH_ERRORS:
            return {
                ...state,
                invoiceErrors: [...action.payload]
            }
        case ACTION_TYPES.FETCH_STATE_PLATE:
            return {
                ...state,
                statePlate: [...action.payload.value]
            }
        case ACTION_TYPES.FETCH_TYPE_PLATE:
            return {
                ...state,
                typePlate: [...action.payload.value]
            }
        case ACTION_TYPES.FETCH_WOPROCEDURE_PLATE:
            return {
                ...state,
                woprocedurePlate: [action.payload]
            }
        default:
            return state
    }
}